import React from 'react';
import dayjs from 'dayjs';

import { Controller } from 'react-hook-form';

function DateInput({ control, name, defaultValue, min }: any) {
  return (
    <Controller
      control={control}
      name={name}
      defaultValue={defaultValue || new Date()}
      render={({ field }) => (
        <input
          {...field}
          className="input input-bordered input-sm"
          type="date"
          min={min}
          value={dayjs(field.value).format('YYYY-MM-DD')}
          onChange={(e) => field.onChange(e)}
        />
      )}
    />
  );
}

export default DateInput;
